// extracted by mini-css-extract-plugin
export default {"editPlayground":"EditPlayground_editPlayground__GePJc","closeIcon":"EditPlayground_closeIcon__rTfgP","addQuestionButton":"EditPlayground_addQuestionButton__n9HE0"};